import { EventRegistry } from './EventRegistry';

export default EventRegistry;
